export default "__VITE_ASSET__DhH1RQbN__"